import { render, staticRenderFns } from "./hkbank.vue?vue&type=template&id=11c1e33f&"
import script from "./hkbank.vue?vue&type=script&lang=js&"
export * from "./hkbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports